import React, { useCallback, useRef, useState } from "react";
import {
  I2cBrand,
  I2cButton,
  I2cInput,
  I2cIcon,
} from "@webcomponents/i2cwebcomponents/dist/react";
import AsideSection from "../../../Components/AsideSection/AsideSection";
// @ts-expect-error
import logo from "../../../assets/images/i2c_logo.svg";
// @ts-expect-error
import banner from "../../../assets/images/login_art.svg";
import { GoogleReCaptcha } from "react-google-recaptcha-v3";
import { Link, useNavigate } from "react-router-dom";
import AuthHeadDesc from "../../../Components/SharedComponent/AuthHeaderSection/AuthHeaderSection";
import { useForm, Controller } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
// import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { validationSchema } from "./ValidationSchema";
import { useMutation } from "react-query";
import AuthService from "../../../Services/AuthServices";
import "./ForgotPassword.scss";
import "../../../Utils/shared-styles/Authentication.scss";
import AlertMessage from "../../../Components/SharedComponent/Alert/Alert";
import ConfirmaionModal from "../../../Components/ConfirmationModal/ConfirmationModal";
import { maskEmail } from "../../../Utils/stringUtls";
import DarkModeBtn from "../../../Components/DarkModeBtn/DarkModeBtn";

const ForgotPassword = () => {
  const form = useRef();
  const userEmail = useRef();
  const [recaptcha, setRecaptcha] = useState("");
  const [showConfirmatonModal, setShowConfirmatonModal] = useState(false);
  const navigate = useNavigate();

  // To stop the continous calling of verification of google recaptcha
  const onVerify = useCallback((token) => {
    setRecaptcha(token);
  }, []);

  // Forgot password mutation
  const forgotPassword = useMutation({
    mutationFn: async (values) => {
      return await AuthService.forgotPassword(values);
    },
    onSuccess: (data) => {
      setShowConfirmatonModal(false);
    },
    onError: (e) => {
      setShowConfirmatonModal(false);
    },
  });

  const forgotPasswordError = forgotPassword.error;

  // FormEventHandler<HTMLFormElement>
  const handleSubmitForm = (e) => {
    if (recaptcha) {
      forgotPassword.mutate({ ...e, recaptcha: recaptcha });
    } else {
    }
  };

  // Hook form initialization and methods
  const methods = useForm({
    resolver: zodResolver(validationSchema),
    mode: "all",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "firstError",
    defaultValues: {
      email: "",
    },
  });

  const windowSize = window.innerWidth;
  // Hook form methods destructuring
  const {
    formState: { errors, isValid },
  } = methods;

  return (
    <React.Fragment>
      <div className="layout_aside">
        <div className="layout_aside-left">
          <AsideSection
            image={banner}
            heading={
              <span>
                Commitment to delivering <br /> exceptional solutions
              </span>
            }
            description={`customer-centric approach and dedication to driving success through seamless implementations`}
          />
        </div>
        <div className="layout_aside-right forStandAlone">
          <div className="right-container">
            <div className="login  auth__main-right">
              <div className="dark-mode-btn-wrapper">
                <DarkModeBtn />
              </div>
              <div className="auth__right-content">
                <div className="login__content-wrapper auth__content-wrapper">
                  <header id="header">
                    <I2cBrand
                      className="login__logo"
                      label="Client Implementation Portfolio"
                      logo={logo}
                      target=""
                    ></I2cBrand>
                  </header>
                  <AuthHeadDesc
                    title={
                      forgotPassword.isSuccess
                        ? "Forgot Password"
                        : "Forgot Password"
                    }
                    classNameDescription={"forgot-password-description"}
                    description={
                      forgotPassword.isSuccess
                        ? "Thank you for the request. We have sent a new password to your verified email."
                        : "If you've forgotten your account password, please confirm your identity by entering your User Email below."
                    }
                  />
                  {!forgotPassword.isSuccess ? (
                    <div className="login__form">
                      <AlertMessage
                        open={forgotPassword.isError}
                        message={
                          forgotPasswordError?.response?.message ??
                          "Something went wrong"
                        }
                      />
                      <form
                        onSubmit={(e) => {
                          !errors.email && setShowConfirmatonModal(true);
                          e.preventDefault();
                        }}
                        ref={form}
                        autoComplete="on"
                      >
                        <div className="">
                          <Controller
                            name="email"
                            control={methods.control}
                            render={({ field }) => (
                              <I2cInput
                                size="large"
                                label="User Email"
                                placeholder="user@i2cinc.com"
                                name="email"
                                type="email"
                                className={`auth__custom-input fw-400`}
                                value={methods.getValues("email")}
                                autofocus
                                required
                                invalid={errors.email ? true : false}
                                ref={userEmail}
                                onI2cInput={field.onChange}
                                onInput={(e) => {
                                  if (e.key === "Enter")
                                    setShowConfirmatonModal(true);
                                }}
                                onI2cBlur={field.onBlur}
                              ></I2cInput>
                            )}
                          />
                          {/* <ErrorMessage
                            show={errors.email ? true : false}
                            message={errors.email?.message ?? "Invalid input"}
                          /> */}
                        </div>
                        <GoogleReCaptcha
                          onVerify={onVerify}
                          refreshReCaptcha={false}
                        />
                        <div className="login__remember-password">
                          <div className="login__remember">
                            <ConfirmaionModal
                              open={showConfirmatonModal}
                              setOpen={() => setShowConfirmatonModal(false)}
                              title={"Reset Password"}
                              headerArt={"linear-tick-circle"}
                              parentClass="custom-dialog-2"
                              message={
                                "Are you sure you want to reset your password?"
                              }
                              layout={"layoutCenter"}
                              confirmBtnVariant={"primary"}
                              handleConfirmation={() => {
                                handleSubmitForm(methods.getValues());
                              }}
                              cancelButtonText={
                                windowSize > 800 ? "Cancel" : "No, I don't want"
                              }
                              confirmButtonText="Confirm"
                              disableConfirmBtn={forgotPassword.isLoading}
                              disableCancelBtn={forgotPassword.isLoading}
                              confirmButtonLoading={forgotPassword.isLoading}
                            />
                            <I2cButton
                              disabled={forgotPassword.isLoading || !isValid}
                              loading={false}
                              onClick={() => {
                                setShowConfirmatonModal(true);
                              }}
                              className="login__sign-btn"
                              size={"large"}
                              type="submit"
                            >
                              Continue
                            </I2cButton>
                          </div>
                          <div className="login__forget-password1">
                            <span
                              className="login-btn-f-pwd"
                              style={{
                                fontSize: "var(--i2c-font-size-text-sm)",
                                color: "var(--text-secondary-700)",
                              }}
                            >
                              Wait, I remember my password.{" "}
                            </span>
                            <Link
                              to={"/login"}
                              style={{
                                color:
                                  "var(--secondary-text, #102BA5)",
                                textDecoration: "underline",
                                fontWeight: 500,
                                fontSize: "var(--i2c-font-size-text-sm)",
                              }}
                            >
                              Login
                            </Link>
                          </div>
                        </div>
                      </form>
                    </div>
                  ) : (
                    <div>
                      <AlertMessage
                        open={true}
                        variant="success"
                        headerArt={"linear-tick-circle"}
                        message={"Email sent successfully!"}
                      />
                      <div className="confirmed-email-display">
                        <I2cIcon
                          name="linear-sms"
                          className="cs-icon-shadowed"
                          variant="shadowed"
                        />
                        <span className="confirmed-email-display-text">
                          {maskEmail(methods.getValues("email"))}
                        </span>
                        <span className="confirmed-email-display-text-small">
                          {maskEmail(methods.getValues("email"), 5)}
                        </span>
                      </div>

                      <div className="confirmed-action-acion-button">
                        <I2cButton
                          variant="primary"
                          size={"medium"}
                          className="login__sign-btn fw-500"
                          style={{ width: "100%" }}
                          onClick={() => navigate("/login")}
                        >
                          <Link
                            to={"/login"}
                            style={{
                              textDecoration: "none",
                              color: "#fff",
                              fontWeight: "500",
                            }}
                          >
                            Back to Login
                          </Link>
                        </I2cButton>
                      </div>
                      <div className="resend-link-text">
                        <span>
                          Didn’t receive? Click{" "}
                          <Link
                            onClick={() =>
                              forgotPassword.mutate(methods.getValues())
                            }
                            style={{color: "var(--secondary-text, #102BA5)" }}
                          >
                            Resend
                          </Link>
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ForgotPassword;
